import createIcon from '../../createIcon';

/**
 * @component @name DateRange
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSAxMUg3VjEzSDlWMTFaTTEzIDExSDExVjEzSDEzVjExWk0xNyAxMUgxNVYxM0gxN1YxMVpNMTkgNEgxOFYySDE2VjRIOFYySDZWNEg1QzMuODkgNCAzLjAxIDQuOSAzLjAxIDZMMyAyMEMzIDIxLjEgMy44OSAyMiA1IDIySDE5QzIwLjEgMjIgMjEgMjEuMSAyMSAyMFY2QzIxIDQuOSAyMC4xIDQgMTkgNFpNMTkgMjBINVY5SDE5VjIwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DateRange = createIcon('DateRange', [
  [
    'path',
    {
      d: 'M9 11H7V13H9V11ZM13 11H11V13H13V11ZM17 11H15V13H17V11ZM19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V9H19V20Z',
      key: '6mh673',
    },
  ],
]);

export default DateRange;
